import { BillingRunStep, BillingRunStepName } from 'hooks/billingRunHooks'

export const STEP_LABELS: Record<BillingRunStepName, string> = {
    generate_invoices: 'Generate invoices',
    send_mails: 'Send invoice mails',
    create_transactions: 'Create transactions',
}

export interface RunStatusMeta {
    label: string
    /** Tailwind classes for a status pill. */
    pill: string
    /** Tailwind classes for a solid indicator dot. */
    dot: string
}

/** Display metadata for a run's status (stale wins over the raw status). */
export function runStatusMeta(run: BillingRunStep): RunStatusMeta {
    if (run.is_stale) {
        return { label: 'stalled', pill: 'bg-red-50 text-red-700', dot: 'bg-red-500' }
    }

    switch (run.status) {
        case 'running':
            return {
                label: 'running',
                pill: 'bg-primary-50 text-primary-700',
                dot: 'bg-primary-500',
            }
        case 'finished':
            return {
                label: 'finished',
                pill: 'bg-green-50 text-green-700',
                dot: 'bg-green-500',
            }
        case 'failed':
            return { label: 'failed', pill: 'bg-red-50 text-red-700', dot: 'bg-red-500' }
        case 'aborted':
            return {
                label: 'aborted',
                pill: 'bg-neutral-100 text-neutral-600',
                dot: 'bg-neutral-400',
            }
    }
}

/** Human duration between start and finish, e.g. "1h 24m"; null while running. */
export function formatDuration(started: string, finished: string | null): string | null {
    if (!finished) {
        return null
    }

    const totalMinutes = Math.round(
        (new Date(finished).getTime() - new Date(started).getTime()) / 60000,
    )
    if (totalMinutes < 1) {
        return '< 1 min'
    }

    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes} min`
}
